module.exports = __webpack_public_path__ + "static/img/iEP-7.06d55f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/iEP-7.jpg
// module id = H9qg
// module chunks = 1